import { memo } from "react";
import { Modal, Upload, message } from "antd";
import { InboxOutlined } from "@ant-design/icons";
import { ALLOWED_INVOICE_UPLOAD_MIME_TYPES } from "../tracker.constants";



function UploadInvoiceModalComponent({
  open,
  uploading,
  invoiceFile,
  onFileSelect,
  onOk,
  onCancel,
}) {
  return (
    <Modal
      title="Upload Invoice"
      open={open}
      onOk={onOk}
      onCancel={onCancel}
      okText="Upload"
      confirmLoading={uploading}
      width={500}
    >
      <Upload.Dragger
        accept=".pdf,.doc,.docx,.xls,.xlsx"
        maxCount={1}
        beforeUpload={(file) => {
          if (!ALLOWED_INVOICE_UPLOAD_MIME_TYPES.includes(file.type)) {
            message.error("Only PDF, DOC, DOCX, XLS, and XLSX files are allowed.");
            return false;
          }
          onFileSelect(file);
          return false;
        }}
        style={{ borderRadius: 8 }}
      >
        <div style={{ padding: "16px 0" }}>
          <InboxOutlined style={{ fontSize: 40, color: "#1677ff" }} />
          <p style={{ fontWeight: 600, marginTop: 12 }}>"Click or drag Invoice Excel to upload"</p>
          <p style={{ color: "#8c8c8c", fontSize: 12 }}>Accepts PDF, DOC, DOCX, XLS, XLSX · Max 20 MB</p>
        </div>
      </Upload.Dragger>
      {invoiceFile && (
        <div
          style={{
            marginTop: 12,
            padding: 8,
            background: "#f6f8fb",
            borderRadius: 4,
            fontSize: 12,
          }}
        >
          Selected file: <strong>{invoiceFile.name}</strong>
        </div>
      )}
    </Modal>
  );
}

export const UploadInvoiceModal = memo(UploadInvoiceModalComponent);
